import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'xm-footer',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './xm-footer.component.html',
})
export class XmFooterComponent {
}
